import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=22afdfbc&scoped=true"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afdfbc",
  null
  
)

export default component.exports